import React, { useState } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
// import { Table } from "antd";
import { getMedicineDescriptionDetails } from "../../../connections/getMedicineDescriptionDetails";
import { deleteMedicineDescription } from "../../../connections/deleteMedicineDescription";
import { toast } from "react-toastify";
import { imagesend } from "../../imagepath";
import { formatDateTime } from "../../../utils/constant/constant";
// const columns = [
//   {
//     title: "Value",
//     dataIndex: "value",
//   },
//   {
//     title: "Doctor",
//     dataIndex: "doctor_name",
//     render: (doctor_name, record) => (
//       <Link
//         to={`/admin/doctor/${record?.doctor_id}`}
//         style={{ textDecoration: "underline" }}
//       >
//         {doctor_name}
//       </Link>
//     ),
//   },
//   {
//     title: "Search Code",
//     dataIndex: "search_code",
//   },
//   {
//     title: "Created At",
//     dataIndex: "created_at",
//     render: (date) => (
//       <>{date}</>
//     ),
//   },
//   {
//     title: "Updated At",
//     dataIndex: "updated_at",
//     render: (date) => (
//       <>{date}</>
//     ),
//   },
// ];
const ShowMedicineDescription = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const [deleteId, setDeleteId] = useState("");
  const navigate = useNavigate();
  const { data: getMedDescData, isLoading } = useQuery({
    queryKey: ["getMedicineDescriptionDetails", id],
    queryFn: () => getMedicineDescriptionDetails(user?.token, id),
    enabled: !!id,
    // staleTime: Infinity, // Keep the data fresh indefinitely

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  // const suppliersListData = getMedDescData ? [getMedDescData] : [];
  const deleteShortCodeFun = async () => {
    try {
      const data = await deleteMedicineDescription(user?.token, deleteId);
      if (data.status.status === "SUCCESS") {
        toast.success("Medicine Description Deleted Successfully", deleteId);
        navigate("/admin/prescription/medicine_descriptions");
        setDeleteId(null);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <>
      <Header />
      <Sidebar activeClassName="medicine_descriptions-dashboard" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Medicine Description Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Medicine Description Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate(
                                    "/admin/prescription/update-medicine_descriptions",
                                    {
                                      state: getMedDescData,
                                    }
                                  );
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setDeleteId(getMedDescData?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Value:</span>
                                  <span className="text">
                                    {getMedDescData?.value || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Doctor:</span>
                                  <span className="text">
                                    {getMedDescData?.doctor_name ? (
                                      <Link
                                        to={`/admin/doctor/${getMedDescData?.doctor_id}`}
                                        style={{ textDecoration: "underline" }}
                                      >
                                        {getMedDescData.doctor_name}
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Search Code:</span>
                                  <span className="text">
                                    {getMedDescData?.search_code || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Created At:</span>
                                  <span className="text">
                                    {getMedDescData?.created_at
                                      ? formatDateTime(getMedDescData?.created_at)
                                      : "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>
                                  <span className="text">
                                    {getMedDescData?.updated_at
                                      ? formatDateTime(getMedDescData?.updated_at)
                                      : "N/A"}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="table-responsive doctor-list">
                      //   <Table
                      //     pagination={false}
                      //     columns={columns}
                      //     dataSource={suppliersListData}
                      //     rowKey={(record) => record.id}
                      //     scroll={{ x: "max-content" }}
                      //   />
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={deleteShortCodeFun}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ShowMedicineDescription;
